import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './our-campaigns.component.scss';
var OurCampaigns = /** @class */ (function (_super) {
    tslib_1.__extends(OurCampaigns, _super);
    function OurCampaigns(element) {
        return _super.call(this, element) || this;
    }
    OurCampaigns.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 2,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 1.8,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    OurCampaigns.prototype.bindEvents = function () { };
    return OurCampaigns;
}(Base));
export { OurCampaigns };



//////////////////
// WEBPACK FOOTER
// ./components/our-campaigns/our-campaigns.component.ts
// module id = 423
// module chunks = 0